<template>
  <div class="modal-backdrop">
    <div class="modal">
      <v-icon id="spinIcon">fas fa-circle-notch fa-spin</v-icon>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'LoadingModal',
    methods: {
    },
  };
</script>
<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: transparent;
    box-shadow: 2px 2px 20px 1px;
    display: flex;
    flex-direction: column;
  }

  .modal #spinIcon {
    font-size: 50px;
    color: white;
  }
</style>


// WEBPACK FOOTER //
// src/common/LoadingModal/LoadingModal.vue